"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const core_1 = require("../../core");
core_1.Log.logLevel = core_1.LogLevels.Silent;
const isFullySupported = () => {
    try {
        const dbName = 'europa';
        const request = window.indexedDB.open(dbName, 2);
        request.onerror = function (event) {
            return false;
        };
        request.onupgradeneeded = function (event) {
            try {
                const db = event.target.result;
                const objectStore = db.createObjectStore('customers', { keyPath: 'testKeyPath' });
                objectStore.transaction.oncomplete = function () {
                    const customerObjectStore = db.transaction('customers', 'readwrite').objectStore('customers');
                    customerObjectStore.add({ testKeyAttr: 'testKeyAttr_value', testKeyPath: 'testKeyPath_value' });
                };
                return true;
            }
            catch (_a) {
                return false;
            }
        };
        request.onsuccess = function () {
            const deleteRequest = window.indexedDB.deleteDatabase(dbName);
            deleteRequest.onerror = function (event) {
                core_1.Log.log(event);
                core_1.Log.log('Error deleting database.');
                return false;
            };
            deleteRequest.onsuccess = function (event) {
                core_1.Log.log(event);
                return true;
            };
        };
        return true;
    }
    catch (e) {
        core_1.Log.log('Error running indexed DB fully support check');
        core_1.Log.log(e);
        return false;
    }
};
exports.default = isFullySupported;
//# sourceMappingURL=indexedDB.fullySupportTest.js.map